import React from 'react';

interface DeleteModalProps {
    isVisible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    message?: string;
}

const DeleteModal1: React.FC<DeleteModalProps> = ({ isVisible, onClose, onConfirm, title, message }) => {
    if (!isVisible) return null;
    return (
        <>
            <div className="modal-backdrop fade show" />
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                                <i className="ti ti-trash-x fs-36" />
                            </span>
                            <h4 className="mb-1">{title || 'Confirm Delete'}</h4>
                            <p className="mb-3">{message || 'Are you sure you want to delete this item?'}</p>
                            <div className="d-flex justify-content-center">
                                <button onClick={onClose} type="button" className="btn btn-light me-3" data-bs-dismiss="modal">
                                    Cancel
                                </button>
                                <button onClick={onConfirm} type="button" className="btn btn-danger" data-bs-dismiss="modal">
                                    Yes, Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeleteModal1;
